exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.container[data-v-15c7083d] {\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n  background: #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-15c7083d&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/Main.vue
// module id = 72
// module chunks = 0